import express, { Router } from 'express';

import * as supportValidation from '@/modules/support/support.validation';
import * as supportController from '@/modules/support/support.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(supportValidation.getSupport),
    supportController.getSupport,
  )
  .post(
    userAuthAndCheckPermissions(),
    validateMiddleware(supportValidation.createSupport()),
    setAuditFields({ mode: AuditMode.CREATE }),
    supportController.createSupport,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(supportValidation.getSupportById),
    supportController.getSupportById,
  )
  .patch(
    userAuthAndCheckPermissions(),
    validateMiddleware(supportValidation.updateSupport()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    supportController.updateSupport,
  );

export default router;
